import React from 'react';

import cx from 'classnames';
import styles from './element_item.module.scss';
import { Slideshow } from '.';

const ElementItem = ({
  type,
  url,
  orientation = 0,
  items = [],
  onClick = () => {},
}) => {
  const classname =
    orientation === 2 ? cx(styles.no_crop) : orientation === 0
      ? cx(styles.crop_landscape)
      : cx(styles.crop_portrait);

  let item = <></>

  if (items.length > 0) {
    item = (
      <Slideshow
        slides={items.map((e) => {
          let el = e.element != null ? e.element : e;
          return {
            url: el.s3_med_url,
            type: el.type,
            duration: e.duration,
          };
        })}
        delay={2000}
        duration={1500}
        nowebgl
      />
    );
  } else {
    item = type === 0 ? (
      <img src={url} alt="" className={classname} />
    ) : (
      <video src={url} loop autoPlay className={classname} muted />
    );
  }

  return (
    <div className={cx(styles.container)} onClick={onClick}>
      {item}
    </div>
  );
};

export default ElementItem;
